<eda-dialog [inject]="dialog">
    <div class="m-1">
        <p i18n="@@conditionsP1">Esta aplicación es una demo.</p>
        <p i18n="@@conditionsP2">No ofrece ninguna garantía y no somos responsables del uso que se haga de la misma.</p>
        <p i18n="@@conditionsP3">Usala bajo tu responsabilidad.</p>
    </div>

    <p-footer class="footer">
        <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix text-right">
            <button type="button" pButton (click)="closeDialog()" class="p-button-raised p-button-danger" i18n-label="@@cerrarBtn" label="Cerrar"></button>
        </div>
    </p-footer>
</eda-dialog>